export enum FCPState {
    PAID = 'paid',
    TRIAL = 'trial',
    CANCELLED = 'cancelled',
    WAITING_FOR_APPROVAL = 'waiting-approval',
}
